import { render, staticRenderFns } from "./PlayerResume.vue?vue&type=template&id=be45427a&scoped=true&"
import script from "./PlayerResume.vue?vue&type=script&lang=ts&"
export * from "./PlayerResume.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerResume.vue?vue&type=style&index=0&id=be45427a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be45427a",
  null
  
)

export default component.exports